import React from "react";
import { useIntl } from "react-intl";

import { BarRow, EmptyState, Panel } from "../../../resusableComponents/funnelFuel";

import { useFilters } from "../lib/FilterContext";
import { fmt } from "../lib/selectors";

const Stat = ({ label, value, note }) => (
  <div className="ff-kpi">
    <div className="ff-lab">{label}</div>
    <div className="ff-val">{value}</div>
    <div className="ff-note">{note}</div>
  </div>
);

/* Companies reached: how the delivered leads spread across employers. Works on every campaign, no target list. */
export const CompaniesPanel = ({ view }) => {
  const intl = useIntl();
  const { toggle, isSelected } = useFilters();
  const { companies } = view;

  const t = (id, defaultMessage) => intl.formatMessage({ id: `ff_dashboard.companies.${id}`, defaultMessage });
  // A company the backend has no name for is never shown by its id.
  const unknownCompany = intl.formatMessage({ id: "ff_dashboard.unknown_company", defaultMessage: "Unknown company" });

  return (
    <Panel
      title={t("title", "Companies reached")}
      caption={t("caption", "How the delivered leads spread across employers — no target list needed")}
    >
      <div className="ff-grid-2">
        <div>
          <h3 className="ff-sub-head">{t("top", "Delivering the most")}</h3>
          {!companies.top.length && (
            <EmptyState>{intl.formatMessage({ id: "ff_dashboard.empty.companies", defaultMessage: "No companies in this selection." })}</EmptyState>
          )}
          {companies.top.map((company) => (
            <BarRow
              key={company.key}
              label={company.label || unknownCompany}
              title={company.label || unknownCompany}
              value={company.count}
              max={companies.topMax}
              labelWidth={188}
              pressed={isSelected(company.selection)}
              onClick={() => toggle(company.selection)}
            />
          ))}
        </div>

        <div>
          <div className="ff-stats">
            <Stat label={t("stat_companies", "COMPANIES")} value={fmt(companies.companyCount)} note={t("stat_companies_note", "with at least one lead")} />
            <Stat label={t("stat_average", "LEADS EACH")} value={companies.averageLeadsPerCompany.toFixed(1)} note={t("stat_average_note", "average across companies")} />
            <Stat label={t("stat_depth", "DEPTH 5+")} value={fmt(companies.depth5Plus)} note={t("stat_depth_note", "companies with 5 or more")} />
          </div>

          <h3 className="ff-sub-head">{t("depth", "How deep into each company")}</h3>
          {/* Display only, like the reference: depth bands are not a filter. */}
          {companies.depthBands.map((band) => (
            <BarRow
              key={band.label}
              label={band.label}
              value={band.count}
              max={companies.depthBandMax}
              note={t("band_note", "companies")}
              labelWidth={108}
            />
          ))}
        </div>
      </div>
    </Panel>
  );
};
